import Main from '../pages/Main/Main';
import Menu from '../pages/Home/Menu/Menu';
import Login from '../pages/Login/Login';
import Home from '../pages/Home/Home';
import Visits from '../pages/Visits/Visits';
import ViewVisitor from '../pages/Visits/ViewVisitor';
import Mail from '../pages/Mail/Mail';
import Shatter from '../pages/Shatter/Shatter';
import Register from '../pages/Login/Register/Register';
import RecoverPassword from '../pages/Login/RecoverPassword/RecoverPassword';
import {
	loginGuard
} from './guards';
import MyAccount from '../pages/MyAccount/MyAccount.vue';
import BroadcastMessages from '../pages/BroadcastMessages/BroadcastMessages';
import RequestAssistance from '../pages/Assistance/RequestAssistance';
import UpdateEmailConfirm from '../pages/MyAccount/ChangeEmail/UpdateEmailConfirm';

export const routes = [{
		path: '/',
		component: Home,
		exact: true,
		name: 'home',
		beforeEnter: loginGuard
	},
	{
		path: '/login',
		component: Login,
		name: 'login'
	},
	{
		path: '/visits',
		component: Visits,
		name: 'visits',
		beforeEnter: loginGuard
	},
	{
		path: '/view-visitor',
		component: ViewVisitor,
		name: 'viewVisitor',
		beforeEnter: loginGuard
	},
	{
		path: '/mail',
		component: Mail,
		name: 'mail',
		beforEnter: loginGuard
	},
	{
		path: '/broadcast-messages',
		component: BroadcastMessages,
		name: 'broadcastMessages',
		beforEnter: loginGuard
	},
	{
		path: '/shatter',
		component: Shatter,
		name: 'shatter'
	},
	{
		path: '/register',
		component: Register,
		name: 'register'
	},
	{
		path: '/recover-password',
		component: RecoverPassword,
		name: 'RecoverPassword'
	},
	{
		path: '/my-account',
		component: MyAccount,
		name: 'MyAccount'
	},
	{
		path: '/request-assistance',
		component: RequestAssistance,
		name: 'requestAssistance'
	},
	{
		path: '/update-email-confirm',
		component: UpdateEmailConfirm,
		name: 'udateEmailConfirm'
	},
];



// WEBPACK FOOTER //
// ./src/router/routes.js